'use strict';

angular.module('substoreApp.services')
    .service('productDataFinalizer', ['uiservice', 'sessionData', function (uiservice, sessionData) {
        /**
         * Depending on actual product state this service might perform some asynchronous finalization tasks.
         * Currently there is only one task implemented: check availability for given product. Because max
         * number of outstanding ajax requests is assumed to be limited, this service provides internal
         * hash maps of products already in check, trying to check each product only once.
         */
        var productsPendingActive = {};
        var productsPendingPassive = [];

        var self = {
            hasUndefinedAvailability: function (product) {
                return (product.productAvailability === 'undefinedAvailability');
            },
            hasNoneAvailability: function (product) {
                return (product.productAvailability === 'noneAvailability');
            },
            isAvailable: function (product) {
                return (!(this.hasUndefinedAvailability(product) || this.hasNoneAvailability(product)));
            },
            checkAvailability: function (product) {
                if (this.hasUndefinedAvailability(product)) {
                    var invokeVerification = !productsPendingActive[product.subscriptionTemplateId];

                    if (invokeVerification) {
                        var subscriptionTemplateId = product.subscriptionTemplateId;
                        productsPendingActive[subscriptionTemplateId] = product;

                        uiservice.getProductAvailability({
                                sessionId: sessionData.sessionId,
                                subscriptionTemplateId: subscriptionTemplateId
                            },
                            function (response) {
                                productsPendingActive[subscriptionTemplateId] = null;
                                if (!response.fault) {
                                    var productAvailability = response.data.productAvailability;
                                    product.productAvailability = productAvailability;
                                    if (self.hasNoneAvailability(product))
                                        product.overrideOrderButtonText = 'product_unavailable';
                                    if (!self.hasUndefinedAvailability(product)) {
                                        for (var i = productsPendingPassive.length - 1; i >= 0; i--) {
                                            var productPending = productsPendingPassive[i];
                                            if (productPending.subscriptionTemplateId === subscriptionTemplateId && self.hasUndefinedAvailability(productPending)) {
                                                productPending.productAvailability = productAvailability;
                                                if (self.hasNoneAvailability(productPending))
                                                    productPending.overrideOrderButtonText = 'product_unavailable';
                                                productsPendingPassive.splice(i, 1);
                                            }
                                        }
                                    }
                                }
                            }
                        );
                    } else {
                        productsPendingPassive.push(product);
                    }
                }
            }
        };

        return self;
    }]);